import { render } from "./ProductDescriptionEntry.vue?vue&type=template&id=4b9d952c&scoped=true&ts=true"
import script from "./ProductDescriptionEntry.vue?vue&type=script&lang=ts"
export * from "./ProductDescriptionEntry.vue?vue&type=script&lang=ts"

import "./ProductDescriptionEntry.vue?vue&type=style&index=0&id=4b9d952c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9d952c"]])

export default __exports__